import React from 'react';

const EmailResult = ({ result }) => {
  if (!result) return null;

  const { subject, body, suggestions } = result;

  return (
    <div className="mt-6 space-y-6">
      {/* 생성된 이메일 */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h3 className="text-lg font-semibold mb-4">생성된 이메일</h3>
        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-medium text-gray-700">제목</h4>
            <p className="mt-1 text-gray-900">{subject}</p>
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-700">본문</h4>
            <div className="mt-1 p-4 bg-gray-50 rounded whitespace-pre-wrap text-gray-900 font-mono">
              {body}
            </div>
          </div>
        </div>
      </div>

      {/* 제안사항 */}
      {suggestions?.length > 0 && (
        <div className="bg-blue-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-4 text-blue-900">작성 제안</h3>
          <ul className="list-disc pl-5 space-y-2">
            {suggestions.map((suggestion, index) => (
              <li key={index} className="text-blue-800">{suggestion}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default EmailResult; 